'use client';
import { isString, isNumber, isObject, isArray } from '@s7/utils';

function toValue(mix) {
    let k, y, result = '';
    if (isString(mix) || isNumber(mix)) {
        result += mix;
    } else if (isObject(mix)) {
        if (isArray(mix)) {
            for(k = 0; k < mix.length; k++){
                if (mix[k]) {
                    if (y = toValue(mix[k])) {
                        result && (result += ' ');
                        result += y;
                    }
                }
            }
        } else {
            for(k in mix){
                if (!mix || mix[k]) {
                    result && (result += ' ');
                    result += k;
                }
            }
        }
    }
    return result;
}
function clsx(...args) {
    let i = 0, tmp, x, result = '';
    while(i < args.length){
        if (tmp = args[i++]) {
            if (x = toValue(tmp)) {
                result && (result += ' ');
                result += x;
            }
        }
    }
    return result;
}

export { clsx };
//# sourceMappingURL=clsx.js.map
